import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { User } from '../../../models/User';
import { Establishment } from '../../../models/Establishment';
import { MissionDetailsComponent } from '../../../pages/etablissement/missions/encour-component/mission-details/mission-details.component';
import { MissionService } from '../../../services/mission.service';
import { MatDialog } from '@angular/material/dialog';
import { SvgIconComponent } from "angular-svg-icon";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { NgClass, NgIf } from "@angular/common";
import { NotificationRealtimeService } from '../../../services/notification-realtime.service';
import { Subscription } from 'rxjs';
import { NotificationPanelComponent } from '../../../shared/components/notification-panel/notification-panel.component';

@Component({
  selector: 'app-agency-header',
  templateUrl: './agency-header.component.html',
  styleUrl: './agency-header.component.scss',
  imports: [
    SvgIconComponent,
    MatMenu,
    NgClass,
    MatMenuItem,
    MatMenuTrigger,
    NgIf,
    NotificationPanelComponent
  ],
  standalone: true
})
export class AgencyHeaderComponent implements OnInit, OnDestroy {
  user: User | null;
  notifNotReaded: number = 0;
  establishment: Establishment | null;
  notification: any[];
  private realtimeSub?: Subscription;

  constructor(
    private authService: AuthService,
    private dialog: MatDialog,
    private router: Router,
    private missionService: MissionService,
    private realtime: NotificationRealtimeService,
  ) {
    this.user = this.authService.user;
  }
  disconnect() {
    localStorage.clear();
    this.authService.disconnect();
  }

  ngOnInit(): void {
    // this.establishment = this.authService.establishment;
    this.notifications();
    // Live updates: prepend new notifications and bump the unread badge without a refresh.
    this.realtime.connect();
    this.realtimeSub = this.realtime.notifications$.subscribe((notif) => {
      this.notification = [notif, ...(this.notification || [])];
      this.notifNotReaded = (this.notifNotReaded || 0) + 1;
    });
  }

  ngOnDestroy(): void {
    this.realtimeSub?.unsubscribe();
    this.realtime.disconnect();
  }
  notifications() {
    this.authService.notif().subscribe({
      next: (res: any) => {
        this.notification = res;
        this.notifNotReaded = res?.filter((el: any) => !el.read).length;
      },
      error: (err) => {
        this.notification = [];
        this.notifNotReaded = 0;
      },
    });
  }

  notifClicked(notif: any) {
    this.authService
      .readNotif(notif.id, { ...notif, read: true })
      .subscribe({
        next: (res) => {
          this.notifications();
          // Extract the embedded link from content
          const linkMatch = notif.content?.match(/\[ETB_LINK:([^\]]+)\]/);
          if (linkMatch && linkMatch[1]) {
            // Navigate to the mission edit page
            this.router.navigate([linkMatch[1]]);
          } else if (notif.mission_id) {
            // Mission-related notification (e.g. a candidate applied): route to the
            // candidate-management surface. Fragmentable missions are managed on a
            // dedicated page; others open the mission-details dialog (candidate tabs).
            this.openMissionCandidateView(notif.mission_id);
          } else {
            // Fallback to dialog if no link found
            this.missionDetailDialog({ id: notif.mission_id });
          }
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  /**
   * Routes a mission-related notification to the right candidate-management surface:
   * fragmentable missions are managed on the dedicated fragment page, others open the
   * mission-details dialog (which embeds the candidate tabs). The notification's
   * mission_id is always the PARENT mission id, which both surfaces expect.
   */
  private openMissionCandidateView(missionId: number) {
    this.missionService.getMissionById(String(missionId), '/v2').subscribe({
      next: (mission: any) => {
        if (mission?.isfragmentable) {
          this.router.navigate(['/agency/fragmented-mision', missionId]);
        } else {
          this.missionDetailDialog({ id: missionId });
        }
      },
      error: () => {
        // Fallback: open the dialog if the mission lookup fails
        this.missionDetailDialog({ id: missionId });
      },
    });
  }

  missionDetailDialog = (row: any) => {
    const dialog = this.dialog.open(MissionDetailsComponent, {
      width: '666px',
      height: '100vh',
      position: { right: '0' },
      backdropClass: 'bg-transparent',
      data: row,
    });
    dialog.afterClosed().subscribe((value) => {
      if (value) {
        // this.fetshMission()
      }
    });
  };

  /**
   * Strips the hidden ETB_LINK pattern from notification content for display
   */
  getDisplayContent(content: string): string {
    if (!content) return '';
    return content.replace(/\[ETB_LINK:[^\]]+\]/g, '').trim();
  }

}
